/**
 * Компонент ProgressBar
 * Красивый прогресс-бар с градиентом и анимацией
 * Автор: AI Market Hub
 */

import { motion } from 'framer-motion';

export default function ProgressBar({
  progress = 0,
  status = '',
  showStatus = true,
  animated = true,
  gradient = 'from-purple-500 via-pink-500 to-purple-500',
  className = '',
  height = 'h-2',
}) {
  const clampedProgress = Math.max(0, Math.min(100, progress));

  return (
    <div className={`space-y-2 ${className}`}>
      {/* Прогресс-бар */}
      <div className={`relative ${height} w-full bg-white/10 rounded-full overflow-hidden`}>
        {/* Фон с градиентом */}
        <motion.div
          className={`absolute inset-0 bg-gradient-to-r ${gradient}`}
          initial={{ width: 0 }}
          animate={{ width: `${clampedProgress}%` }}
          transition={animated ? { duration: 0.3, ease: 'easeOut' } : { duration: 0 }}
        >
          {/* Shimmer эффект */}
          {animated && clampedProgress > 0 && (
            <motion.div
              className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent"
              animate={{
                x: ['-100%', '100%'],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'linear',
              }}
            />
          )}
        </motion.div>

        {/* Свечение при активной загрузке */}
        {clampedProgress > 0 && clampedProgress < 100 && (
          <div className="absolute inset-0 shadow-lg shadow-purple-500/50" />
        )}
      </div>

      {/* Статус текст */}
      {showStatus && status && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-sm text-gray-400 flex items-center gap-2"
        >
          <span className="w-2 h-2 bg-purple-400 rounded-full animate-pulse" />
          {status}
          {clampedProgress > 0 && (
            <span className="text-purple-400 font-medium ml-auto">
              {Math.round(clampedProgress)}%
            </span>
          )}
        </motion.p>
      )}
    </div>
  );
}




